export default __webpack_public_path__ + "static/media/mc_3.c1ef343d.png";